// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_d72bbd3","icon":"_417e46d","inPlay":"_4b87cd5","won":"_3ab6403","lost":"_a5c5a3a","placed":"_3eac463","voided":"_d8ed936","deadHeat":"_20161ae","sgm":"_c606bbb"};